import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — bei jedem Pathname-Wechsel scrollen wir die Seite an den Anfang.
 * Wird einmal global in <BrowserRouter> eingehängt.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // instant statt smooth — Booking.com / AmEx Pattern: neue Seite startet direkt oben
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
